import fetchPosts from '../fetch/fetch-posts'
import { ARCHIVE_BUTTON, ARCHIVE_TAX_SLUG, ARCHIVE_PARENT_TAX_SLUG } from '../constants'

export default function taxonomyFilter(archive) {
    const filterButtons = archive.querySelectorAll(`[${ARCHIVE_BUTTON}]`)

    if (filterButtons.length > 0) {
        filterButtons.forEach(button => button.addEventListener('click', () => {
            const taxSlug = button.getAttribute(ARCHIVE_TAX_SLUG)
            const categoryParent = button.closest(`[${ARCHIVE_PARENT_TAX_SLUG}="${taxSlug}"]`)

            if (!categoryParent) {
                return
            }

            // Get active button
            const activeButton = categoryParent.querySelector(`.active[${ARCHIVE_TAX_SLUG}]`)
            // Change active class on buttons
            activeButton.classList.remove('active')
            button.classList.add('active')
            // Fetch posts
            fetchPosts(archive, button)
        }))
    }
}